import { GET_FORWARDER_E_WALLET_BALANCE } from './actionTypes';

import eWalletAccountRemote from '../../api/eWalletAccountRemote';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import ForwarderInvoiceBalance from '../../models/ForwarderGhaInvoiceBalance';

import { receiveError } from './notificationAction';

function balanceSuccess(balance: ForwarderInvoiceBalance) {
  return {
    type: GET_FORWARDER_E_WALLET_BALANCE,
    data: balance
  };
}

function receiveWalletBalance(ghaId: number): (dispatch: Function) => void {

  return (dispatch: Function) => {

    eWalletAccountRemote.getWalletBalance(ghaId).then((resp: ApiResponse<ForwarderInvoiceBalance>) => {

      const balance: ForwarderInvoiceBalance | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
    
      if (balance) {
        dispatch(balanceSuccess(balance));
      };
    
      if (error) {
        dispatch(receiveError(error));
      };
    });
  };
};

export {
  receiveWalletBalance
};
